import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { Column, ColumnEditorOptions } from "primereact/column";
import { Fetch } from "../../shared/Fetch";
import { AcknowledgeEmailSelectTable } from "./AcknowledgeEmailSelectTable";

interface IAcknowledgeTable {
    id?: number,
    company_Name?: string,
    branch_ID?: number,
    branchName?: string,
    // email_To?: string,
    // email_CC?: string,
    // email_BCC?: string,
    updated_By?: string,
    updated_On?: Date,
}

export const AcknowledgeTable = (toast: any) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IAcknowledgeTable[], loading: boolean });
    const [openEmailsModal, setOpenEmailsModal] = useState({ open: false, singleData: {} } as { open: boolean, singleData: IAcknowledgeTable });
    const dt = useRef<any>(null);

    const header = () => {
        return <p>Timesheet Email Sending Acknowledge Setting</p>;
    }

    const isPositiveInteger = (val: any) => {
        let str = String(val);

        str = str.trim();

        if (!str) {
            return false;
        }

        str = str.replace(/^0+/, '') || '0';
        let n = Math.floor(Number(str));

        return n !== Infinity && String(n) === str && n >= 0;
    };

    const updatedOn = (rowData: any) => {
        let date;
        if (rowData.updated_On) date = format(new Date(rowData.updated_On), 'dd/MM/yyyy HH:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const updateRow = async (updateData: IAcknowledgeTable) => {
        //email_To: updateData.email_To, email_CC: updateData.email_CC, email_BCC: updateData.email_BCC
        const response = await Fetch(`Timesheet/updateSendEmailAcknowledge`, "PUT", { id: updateData.id, branch_ID: updateData.branch_ID, updated_By: 0, updated_On: updateData.updated_On }, null, toast);
        if (response) {
            loadTableData();
            return true;
        } else return false;
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });

        const response = await Fetch(`Timesheet/getSendEmailAcknowledge`, "GET", null, null, toast);
        if (response) {
            const data: Array<IAcknowledgeTable> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    // const onCellEditComplete = async (e: any) => {
    //     let { rowData, newValue, field, originalEvent: event } = e;

    //     switch (field) {
    //         case 'quantity':
    //         case 'frequency_Days':
    //             if (isPositiveInteger(newValue)) rowData[field] = newValue;
    //             else event.preventDefault();
    //             break;

    //         default:
    //             if (newValue.trim().length > 0) rowData[field] = newValue;
    //             else event.preventDefault();
    //             break;
    //     };

    //     let updateData: any = rowData;
    //     updateData.frequency_Days = newValue;
    //     if (await updateRow(updateData)) {
    //         setTableData(prev => {
    //             const updatedData = prev.tableData.map(item => {
    //                 if (item.id === rowData.id) {
    //                     return { ...item, frequency_Days: newValue };
    //                 }
    //                 return item;
    //             });
    //             return { ...prev, tableData: updatedData };
    //         })
    //     };
    // };

    const onCellEditCompleteTo = async (e: any) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        switch (field) {
            case 'quantity':
            case 'email_To':
                if (newValue) rowData[field] = newValue;
                else event.preventDefault();
                break;

            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        };

        let updateData: any = rowData;
        updateData.email_To = newValue;
        if (await updateRow(updateData)) {
            setTableData(prev => {
                const updatedData = prev.tableData.map(item => {
                    if (item.id === rowData.id) {
                        return { ...item, email_To: newValue };
                    }
                    return item;
                });
                return { ...prev, tableData: updatedData };
            })
        };
    };

    const onCellEditCompleteCc = async (e: any) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        switch (field) {
            case 'quantity':
            case 'email_CC':
                if (newValue) rowData[field] = newValue;
                else event.preventDefault();
                break;

            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        };

        let updateData: any = rowData;
        updateData.email_CC = newValue;
        if (await updateRow(updateData)) {
            setTableData(prev => {
                const updatedData = prev.tableData.map(item => {
                    if (item.id === rowData.id) {
                        return { ...item, email_CC: newValue };
                    }
                    return item;
                });
                return { ...prev, tableData: updatedData };
            })
        };
    };

    const onCellEditCompleteBcc = async (e: any) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        switch (field) {
            case 'quantity':
            case 'email_BCC':
                if (newValue) rowData[field] = newValue;
                else event.preventDefault();
                break;

            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        };

        let updateData: any = rowData;
        updateData.email_BCC = newValue;
        if (await updateRow(updateData)) {
            setTableData(prev => {
                const updatedData = prev.tableData.map(item => {
                    if (item.id === rowData.id) {
                        return { ...item, email_BCC: newValue };
                    }
                    return item;
                });
                return { ...prev, tableData: updatedData };
            })
        };
    };

    const cellEditor = (options: ColumnEditorOptions) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            if (options.editorCallback) {
                options.editorCallback(e.target.value);
            }
        };

        return <input style={{ width: '100%', margin: 0, padding: '3px 5px', border: '2px solid green', outline: 'none', cursor: "pointer" }} value={options.value} type='text' onChange={(e) => handleChange(e)} />
    };

    useEffect(() => {
        loadTableData();
    }, []);

    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", height: "67vh" }}
                ref={dt} size="small" lazy dataKey="branch_ID" stripedRows scrollable scrollHeight="60vh" showGridlines responsiveLayout="scroll"
                value={tableData.tableData} exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} style={{ minWidth: "3rem", maxWidth: "3rem" }} />
                <Column field="company_Name" header="Company Name" style={{ minWidth: "13rem" }} />
                <Column field="branchName" header="Branch Name" style={{ minWidth: "12rem", maxWidth: "12rem" }} />
                <Column field="" header="Email's" style={{ minWidth: "10rem" }} body={(rowData: any) => <div><p onClick={() => setOpenEmailsModal({ open: true, singleData: rowData })} className="pi pi-envelope cursor-pointer text-primary ml-8"></p></div>} />
                {/* <Column field="frequency_Days" header="Frequency Days" editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} /> */}
                {/* <Column field="email_To" header="Email To" editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditCompleteTo} /> */}
                {/* <Column field="email_CC" header="Email To CC" editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditCompleteCc} /> */}
                {/* <Column field="email_BCC" header="Email To BCC" editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditCompleteBcc} /> */}
                {/* <Column field="updated_By" header="Updated By" style={{maxWidth: "10rem"}} /> */}
                {/* <Column field="updated_On" header="Updated On" body={updatedOn} style={{minWidth: "12rem"}} /> */}
            </DataTable>
            <AcknowledgeEmailSelectTable open={openEmailsModal.open} singleData={openEmailsModal.singleData} hideDialog={() => setOpenEmailsModal({ open: false, singleData: {} })} toast={toast} />
        </>
    );
}